import { render, staticRenderFns } from "./cards.vue?vue&type=template&id=955e35ae&scoped=true"
import script from "./cards.vue?vue&type=script&lang=js"
export * from "./cards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955e35ae",
  null
  
)

export default component.exports